module.exports = __webpack_public_path__ + "static/color-wheel2-7dea0e85f843f639cf2dec9b9dff4e31.png";